import { Grid, Typography } from "@material-ui/core";

import MeditocInfoField from "../../../utils/MeditocInfoField";
import MeditocModal from "../../../utils/MeditocModal";
import { useSistema } from "../../../../context/SistemaContext";

export default function EliminarBoton() {
    const {
        botonSeleccionado,
        modalOpenEliminarBoton,
        handleOpenEliminarBoton,
        handleSubmitEliminarBoton,
    } = useSistema();

    return (
        <MeditocModal
            title="Eliminar botón"
            open={modalOpenEliminarBoton}
            okfunc={handleSubmitEliminarBoton}
            setopen={handleOpenEliminarBoton}
            align="center"
            size="small"
        >
            <Grid container spacing={1} className="center">
                <Grid item xs={12}>
                    <Typography paragraph align="center">
                        ¿Desea eliminar el siguiente botón?
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <MeditocInfoField label="ID de módulo:" value={botonSeleccionado.iIdModulo} />
                </Grid>
                <Grid item xs={12}>
                    <MeditocInfoField label="ID de submódulo:" value={botonSeleccionado.iIdSubModulo} />
                </Grid>
                <Grid item xs={12}>
                    <MeditocInfoField label="ID de botón:" value={botonSeleccionado.iIdBoton} />
                </Grid>
                <Grid item xs={12}>
                    <MeditocInfoField label="Nombre del botón:" value={botonSeleccionado.sNombre} />
                </Grid>
            </Grid>
        </MeditocModal>
    );
}
